<template>
  <div>
    <b-modal size="xl" id="banner-preview" title="Banner Preview" :hide-footer="hideFooter">
      <span v-html="html"></span>
    </b-modal>
  </div>
</template>

<script>
import { Bus } from '@/main'
export default {
  data () {
    return {
      html: '<h1>Preview test</h1>',
      hideFooter: true
    }
  },
  created () {
    Bus.$on('previewHtml', (html) => { this.html = html })
  },
  beforeDestroy () {
    Bus.$off('previewHtml')
  }
}
</script>
